import { TrackingEvent, type Traits } from '../types'

export interface JOProgressArgs {
  JOProgressID: string
  ActivityDateTime: string
  SiteID?: string
}

export class JOProgress extends TrackingEvent {
  properties: JOProgressArgs

  constructor(args: JOProgressArgs) {
    const { JOProgressID, ActivityDateTime, SiteID } = args

    super('JOProgress', 'energy.JOProgress.v3')

    this.properties = {
      JOProgressID,
      ActivityDateTime,
      SiteID,
    }
  }
}
